/** Use saved net board runs, not room perimeter or a stale whole-site aggregate. */
export function skirtingRoomRuns(doc) {
    return doc.assessment.plan.flatMap(floor => {
        const rows = floor.skirting.rooms;
        const area = doc.assessment.areas.find(a => a.name === floor.name);
        const included = rows.flatMap(run => {
            const assessed = doc.assessment.rooms.find(r => r.id === run.area_id) ?? doc.assessment.rooms.find(r => r.name === run.name && area && r.area_id === area.id);
            const drawn = floor.rooms.find(r => r.id === run.area_id);
            if (assessed?.out_of_scope || assessed?.is_void || drawn?.out_of_scope || drawn?.is_void)
                return [];
            return [{ id: run.area_id || `${floor.name}:${run.name}`, name: `${floor.name} · ${run.name}`, quantity: run.skirting_m }];
        });
        // Floor-owned runs have no room to exclude. Preserve them explicitly, never hide them in a room.
        const loose = Math.max(0, floor.skirting.skirting_lm - rows.reduce((n, r) => n + r.skirting_m, 0));
        return [...included, ...(loose > .005 ? [{ id: `floor:${floor.name}:unassigned`, name: floor.name, quantity: loose }] : [])];
    });
}
export function selectedSkirtingQuantity(runs, excluded = []) { return Math.round(runs.filter(r => !excluded.includes(r.id)).reduce((n, r) => n + r.quantity, 0) * 100) / 100; }
export function overrideServiceQuantity(line, quantity) {
    // Older generated names embedded the old quantity and would otherwise contradict the edited field.
    const name = line.service_id === 'skirting' && /^Skirting — [\d.]+ LM \(drawn run\)$/.test(line.name) ? 'Skirting' : line.service_id === 'skirting' && /^踢脚线——[\d.]+ 延米（图纸实测）$/.test(line.name) ? '踢脚线' : line.name;
    return { name, quantity, quantity_source: 'manual' };
}
//# sourceMappingURL=proposal-skirting.js.map